import $ from 'jquery';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  function getFlatRateServiceIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    ids = ids.filter((id) => id);

    return new Set(ids);
  }

  function setFlatRateServiceIds(ids) {
    const params = queryString();

    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateFlatRateServicesControls() {
    const selectedCheckboxesLength = $('.checkbox--flat-rate-services:checked').length;
    const flatRateServicesCount = $('.data-table__tr').length;
    const totalSelectedFlatRateServices = getFlatRateServiceIds().size;

    if (totalSelectedFlatRateServices > 0) {
      updateTextOnly(
        $('.h-d-button--delete-flat-rate-services'),
        `Delete (${totalSelectedFlatRateServices})`
      ).removeClass('hide');

      $('.flat-rate-services-search-form').hide();
    } else {
      $('.h-d-button--delete-flat-rate-services').addClass('hide');
      $('.flat-rate-services-search-form').show();
    }

    // check/uncheck the "check all" checkbox based on count
    $('.checkbox--flat-rate-services-check-all').prop(
      'checked',
      selectedCheckboxesLength === flatRateServicesCount
    );
  }

  $(document).ready(() => {
    getFlatRateServiceIds().forEach((flatRateServiceId) => {
      $(`.data-table__tr[data-id=${flatRateServiceId}]`)
        .find('.checkbox--flat-rate-services')
        .prop('checked', true);
    });
    updateFlatRateServicesControls();
  });

  $(document).on('change', '.checkbox--flat-rate-services', (e) => {
    const ids = getFlatRateServiceIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if ($(e.target).is(':checked')) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setFlatRateServiceIds(ids);
    updateFlatRateServicesControls();
  });

  $(document).on('change', '.checkbox--flat-rate-services-check-all', (e) => {
    $('.checkbox--flat-rate-services').prop('checked', $(e.target).prop('checked')).change();

    updateFlatRateServicesControls();
  });

  $(document).on('click', '.h-d-button--delete-flat-rate-services', (e) => {
    const selectedFlatRateServiceIds = Array.from(getFlatRateServiceIds());

    let bulkDeleteUrl = $(
      '.modal--delete-flat-rate-services-confirmation .d-button--confirm-delete'
    ).attr('href');

    if (/\?flat_rate_service_ids=.+$/.test(bulkDeleteUrl)) {
      bulkDeleteUrl = bulkDeleteUrl.replace(/\?flat_rate_service_ids=.+$/, '');
    }

    bulkDeleteUrl = `${bulkDeleteUrl}?flat_rate_service_ids=${selectedFlatRateServiceIds}`;

    $('.modal--delete-flat-rate-services-confirmation .d-button--confirm-delete').attr(
      'href',
      bulkDeleteUrl
    );

    $('.modal--delete-flat-rate-services-confirmation .modal__header').text(
      `Are you sure you want to delete ${selectedFlatRateServiceIds.length} selected services?`
    );

    $('.modal--delete-flat-rate-services-confirmation').modal();
  });

  $(document).on('click', '.flat-rate-services-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.flat-rate-services-search-form__field').val('');
    $el.parents('.flat-rate-services-search-form').submit();
  });
});
